<template>
  <div class="browser-container">
    <div class="wrapper">
      <h1 class="title">Enter Deposit Amount</h1>
      <form class="container">
        <div class="amount-wrapper">
          <div class="amount-group">
            <input type="tel" id="amount" v-model.number="currencyAmount" @keyup="validateKeyup" maxlength="5"/>
            <span class="bar"></span>
            <label class="amount-label" for="amount">EUR</label>
          </div>
        </div>
        <ul class="result">
          <li class="result-item">
            <span class="result-label">1 BTС =</span>
            <div class="rate">
              <span class="result-text">
                <span class="result-unit">&#8364;</span>
                <span class="result-number">{{rate}}</span>
              </span>
              <!--<Countdown time="30" class="timer"></Countdown>-->
            </div>

          </li>
          <li class="result-item">
            <span class="result-label">Total:</span>
            <span class="result-text">
              <span class="result-unit">&#8364;</span>
              <span class="result-number">{{formattedCurrencyAmount}}</span>
            </span>
          </li>
          <li class="result-item">
            <span class="result-label">Purchase Amount:</span>
            <span class="result-text">
              <span class="result-number">{{rateDivided}}</span>
              <span class="result-unit">&nbsp;BTC</span>
            </span>
          </li>
        </ul>
        <router-link to="/step4">
          <button class="button-continue">Continue</button>
        </router-link>
      </form>
    </div>
  </div>
</template>

<script>
import Countdown from '../Countdown.vue';

export default {
  name: 'Step3',
  components: {
    Countdown
  },
  data() {
    return {
      currencyAmount: '100',
      rate: 8878.52
    };
  },
  computed: {
    rateDivided () {
      return (this.currencyAmount / this.rate)
        .toLocaleString(undefined, { maximumFractionDigits: 4 });
    },
    formattedCurrencyAmount () {
      let value = this.currencyAmount;
      if (value > 999)
        value = value.toLocaleString('en') ;
      return value;
    }
  },
  methods: {
    validateKeyup(event) {
      const charCode = (event.which) ? event.which : event.keyCode;
      // strip not numbers
      if ((charCode < 48 || charCode > 57)) {
        event.target.value = event.target.value.replace(event.key, '');
      }
      return event.target.value;
    }
  },
  beforeDestroy() {
    if (this.currencyAmount) {
      this.$store.formattedCurrencyAmount = this.formattedCurrencyAmount;
      this.$store.rateDivided = this.rateDivided;
    }
  }
};
</script>

<style scoped>
@import "../../styles/colors.css";
@import "../../styles/consts.css";

.container {
  width: 433px;
  height: 344px;
  border-radius: 8px;
  box-shadow: 0 3px 2px -2px $gainsboro;
  border: solid 1px $white-smoke;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: $ghost-white;
}

.amount-wrapper {
  height: 168px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $white;
}

.amount-group {
  position: relative;
}

#amount {
  padding: 10px 10px 10px 5px;
  display: block;
  width: 95px;
  height: 48px;
  border: none;
  @include proxima_regular;
  font-size: calc(24rem / 16);
  line-height: 2;
  text-align: left;
  color: $nickel;
  &:focus {
    outline: none;
  }
}

/* BOTTOM BARS */
.bar {
  position: relative;
  display: block;
  width: 140px;
  height: 1px;
  background-color: $blue;

  &:before, &:after {
    content: '';
    height: 2px;
    width: 0;
    bottom: 1px;
    position: absolute;
    background: $blue;
    transition: 0.2s ease all;
  }

  &:before {
    left: 50%;
  }

  &:after {
    right: 50%;
  }
}

/* active state */
#amount:focus {
  & ~ .bar:before, & ~ .bar:after  {
    width: 50%;
  }
}

/* LABEL  */
.amount-label {
  @include proxima_semibold;
  font-size: calc(12rem / 16);
  line-height: 1.17;
  letter-spacing: 0.6px;
  color: $cadet-gray;
  position:absolute;
  bottom: 14px;
  right: 8px;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}

/* active state */
#amount:focus  ~ .amount-label {
  color: $blue;
}

.result {
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 370px;
  /*margin: 28px auto;*/

  &-item {
    display: flex;
    flex-direction: column;
  }

  &-item:nth-child(2) {
    align-items: center;
  }

  &-item:nth-child(3) {
    align-items: flex-end;
  }

  &-label {
    @include proxima_regular;
    font-size: 14px;
    text-align: left;
    color: $cadet-gray;
    white-space: nowrap;
  }

  &-text {
    white-space: nowrap;
    display: flex;
  }

  &-number {
    @include proxima_semibold;
    color: $nickel;
    font-size: 1rem;
    max-width: 100px;
    overflow: hidden;
  }

  &-unit {
    @include proxima_semibold;
    color: $nickel;
    font-size: 1rem;
  }
}

.rate {
  display: flex;
  align-items: center;
}

.timer {
  width: 30px;
  height: 16px;
  border-radius: 3px;
  background-color: $blue;
  color: $white;
  @include proxima_semibold;
  font-size: calc(10rem / 16);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 7px;
}

.button-continue {
  width: 370px;
  height: 48px;
  border-radius: 4px;
  background-color: $blue;
  @include proxima_semibold;
  color: $white;
  font-size: 1rem;
  cursor: pointer;
  outline: none;
  border: 0;

  &:hover {
    background-color: $dark-blue;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/Step3.vue